"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Leaf, Droplets, Recycle, Heart } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function QualityAndSustainability() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="calidad-y-sostenibilidad" className="bg-background section px-4 md:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={leftRef} className={`transition-all duration-700 ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="grid grid-cols-2 gap-4">
              <div data-index={0} className="col-span-2 h-64 rounded-xl overflow-hidden bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/rich_organic_soil_closeup.png" alt="Suelo orgánico rico" className="hero-img w-full h-full object-cover" />
              </div>
              <div data-index={1} className="h-48 rounded-xl overflow-hidden bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/olive_tree_leaves_sunlight.png" alt="Hojas de olivo al sol" className="hero-img w-full h-full object-cover" />
              </div>
              <div data-index={2} className="h-48 rounded-xl overflow-hidden bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/water_recycling_system_detail.png" alt="Sistema de reciclaje de agua" className="hero-img w-full h-full object-cover" />
              </div>
              <div data-index={3} className="col-span-2 h-56 rounded-xl overflow-hidden bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552070/img/sustainable_farming_tools.png" alt="Herramientas de cultivo sostenible" className="hero-img w-full h-full object-cover" />
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`space-y-8 transition-all duration-700 delay-200 ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="space-y-4">
              <h2 className="font-serif text-4xl md:text-5xl font-bold text-secondary leading-tight">
                Calidad y Sostenibilidad
              </h2>
              <p className="text-foreground text-lg leading-relaxed">
                Nuestro compromiso con la tierra y el medio ambiente se refleja
                en cada botella de aceite que producimos. Desde prácticas
                agrícolas orgánicas hasta la gestión responsable de recursos,
                cuidamos cada detalle.
              </p>
            </div>

            <div className="space-y-6">
              <Card data-index={0} className="">
                <CardContent className="flex gap-4 items-start pt-6">
                  <div className="shrink-0 w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center">
                    <Leaf className="w-6 h-6 text-secondary" />
                  </div>
                  <div className="space-y-2">
                    <h3 className="font-semibold text-lg text-secondary">
                      Cultivo Orgánico
                    </h3>
                    <p className="text-muted-foreground text-sm leading-relaxed">
                      Utilizamos métodos de cultivo 100% orgánicos, sin
                      pesticidas ni fertilizantes químicos, respetando los
                      ciclos naturales de la tierra y promoviendo la
                      biodiversidad.
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card data-index={1} className="">
                <CardContent className="flex gap-4 items-start pt-6">
                  <div className="shrink-0 w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center">
                    <Droplets className="w-6 h-6 text-secondary" />
                  </div>
                  <div className="space-y-2">
                    <h3 className="font-semibold text-lg text-secondary">
                      Gestión Eficiente del Agua
                    </h3>
                    <p className="text-muted-foreground text-sm leading-relaxed">
                      Implementamos sistemas de riego por goteo y reciclaje de
                      agua para minimizar el consumo, asegurando que cada gota
                      cuenta en nuestro proceso de producción.
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card data-index={2} className="">
                <CardContent className="flex gap-4 items-start pt-6">
                  <div className="shrink-0 w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center">
                    <Recycle className="w-6 h-6 text-secondary" />
                  </div>
                  <div className="space-y-2">
                    <h3 className="font-semibold text-lg text-secondary">
                      Reducción de Residuos
                    </h3>
                    <p className="text-muted-foreground text-sm leading-relaxed">
                      Transformamos los subproductos del olivar en compost y
                      biomasa, logrando un ciclo de producción circular que
                      minimiza residuos y enriquece el suelo.
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card data-index={3} className="">
                <CardContent className="flex gap-4 items-start pt-6">
                  <div className="shrink-0 w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center">
                    <Heart className="w-6 h-6 text-secondary" />
                  </div>
                  <div className="space-y-2">
                    <h3 className="font-semibold text-lg text-secondary">
                      Compromiso con la Calidad
                    </h3>
                    <p className="text-muted-foreground text-sm leading-relaxed">
                      Cada oliva es cosechada en su punto óptimo de maduración
                      y procesada inmediatamente, garantizando un aceite de
                      máxima calidad y pureza con trazabilidad completa.
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </section>;
}